import { render, staticRenderFns } from "./SBPaymentMethodSelect.html?vue&type=template&id=3629184e&scoped=true&"
import script from "./SBPaymentMethodSelect.ts?vue&type=script&lang=ts&"
export * from "./SBPaymentMethodSelect.ts?vue&type=script&lang=ts&"
import style0 from "./SBPaymentMethodSelect.css?vue&type=style&index=0&id=3629184e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629184e",
  null
  
)

export default component.exports